import { render } from "./BuildEnv.vue?vue&type=template&id=1a359150"
import script from "./BuildEnv.vue?vue&type=script&lang=js"
export * from "./BuildEnv.vue?vue&type=script&lang=js"

import "./BuildEnv.vue?vue&type=style&index=0&id=1a359150&lang=css"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__